/**
 * The deal state machine — one source of truth for the legal transitions. The server enforces it;
 * the web shows only the allowed next actions. Ported verbatim from the verified legacy rules.
 */
export const DEAL_STATES = [
    'Inquiry',
    'Offer',
    'Confirmed',
    'Delivered',
    'Closed',
    'Lost',
    'Expired',
    'Cancelled',
];
/** Allowed next states from each state. Empty = terminal. */
export const TRANSITIONS = {
    Inquiry: ['Offer', 'Lost'],
    Offer: ['Confirmed', 'Lost', 'Expired', 'Offer'],
    Confirmed: ['Delivered', 'Cancelled'],
    Delivered: ['Closed'],
    Closed: [],
    Lost: [],
    Expired: ['Offer'],
    Cancelled: [],
};
export function canTransition(from, to) {
    return TRANSITIONS[from].includes(to);
}
export const STATE_LABELS_FA = {
    Inquiry: 'استعلام',
    Offer: 'پیشنهاد',
    Confirmed: 'قطعی',
    Delivered: 'تحویل',
    Closed: 'بسته',
    Lost: 'ازدست‌رفته',
    Expired: 'منقضی',
    Cancelled: 'لغو',
};
/** English twin of STATE_LABELS_FA — for English screens (staged i18n rollout). */
export const STATE_LABELS_EN = {
    Inquiry: 'Inquiry',
    Offer: 'Offer',
    Confirmed: 'Confirmed',
    Delivered: 'Delivered',
    Closed: 'Closed',
    Lost: 'Lost',
    Expired: 'Expired',
    Cancelled: 'Cancelled',
};
//# sourceMappingURL=dealState.js.map